// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"6cb9b1c3","977":"8e30cde1"}[chunkId] + ".chunk.js";
};